/**
 * Javascript specific to the mobile header
 */
define(['jquery', 'domReady!'], ($) => {
    function handlerMobileHeaderSearchClick(e) {
        e.preventDefault();

        const $headerMinisearchClear = $('#mobile-search-close'); // Clear text icon for search bar
        const $headerMinisearch = $('.site-header__mobile-top .minisearch'); // Be sure to only target the mobile one
        const $headerMinisearchText = $headerMinisearch.find('.minisearch__control--text');

        if ($headerMinisearch.hasClass('hidden')) {
            $headerMinisearch.removeClass('hidden');

            // Automatic focus on the search field so the user can start typing right away
            $headerMinisearchText.on('focus', function () {
                // Javascript hack that will set the cursor to the end of the current value of the search field, if one is
                // already there. Makes it easier for the user to perform subsequent searches
                this.value = this.value;
                $headerMinisearchClear.addClass('showThis'); // Show the clear button
            });
            $headerMinisearchText.focus();

            // If the search field loses focus, hide it
            $('[data-id="mobile-search"]').one('focusout', () => {
                // $headerMinisearchClear.removeClass('showThis');
                // $headerMinisearch.addClass('hidden');
            });
        } else {
            // User has clicked the search button again while the search field is visible, indicating they want to hide it
            $headerMinisearchClear.removeClass('showThis');
            $headerMinisearch.addClass('hidden');
            $('[data-id="mobile-search"]').off('focusout'); // Prevent event listeners stacking up
        }
    }

    $(document.body).on('click', '.mobile-header-search-toggle', handlerMobileHeaderSearchClick);
});
